<template>
  <div class="tax-config">
    <KTCodePreview v-bind:title="'Thuế TNCN'">
      <template v-slot:toolbar>
        <div class="row">
          <div class="ml-3">
            <b-button variant="primary" size="sm" @click="showTaxConfigModal()">
              <i style="font-size: 1rem" class="flaticon2-add-1"></i>Tạo mới
            </b-button>
          </div>
        </div>
      </template>
      <template v-slot:preview>
        <b-table :items="mainList.dataset" :fields="fields" bordered>
          <template v-slot:cell(isActive)="row">
            <span v-if="row.item.isActive">
              <b-badge variant="success">Hoạt động</b-badge>
            </span>
            <span v-else>
              <b-badge variant="danger">Ngừng hoạt động</b-badge>
            </span>
          </template>
          <template v-slot:cell(actions)="row">
            <b-dropdown size="sm" id="dropdown-left" no-caret right>
              <template slot="button-content">
                <i
                  style="font-size: 1rem; padding-right: 0px"
                  class="flaticon2-settings"
                ></i>
              </template>
              <b-dropdown-item @click="showTaxConfigModal(row.item.id)">
                <span style="color: #3f4254; font-size: 12px">
                  <i
                    style="font-size: 1rem"
                    class="flaticon2-pen icon-color"
                  ></i>
                  &nbsp; Chỉnh sửa
                </span>
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </b-table>
        <TaxConfigModal
          ref="tax-config-modal"
          v-on:on-submit-success="fetchMainData()"
        />
      </template>
    </KTCodePreview>
  </div>
</template>

<script>
import ApiService from '@/core/services/api.service';
import KTCodePreview from '@/view/content/CodePreview.vue';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';

import { makeToastFaile } from '@/utils/common';
import TaxConfigModal from '../../components/tax-configs/TaxConfigModal';
import { TIME_TRIGGER } from '@/utils/constants';

export default {
  components: {
    KTCodePreview,
    TaxConfigModal,
  },
  data() {
    return {
      mainList: {
        dataset: [],
        total: 0,
        pages: 1,
      },
      fields: [
        {
          key: 'name',
          label: 'Tên',
          thStyle: {
            width: '30%',
          },
        },
        {
          key: 'contractTypeName',
          label: 'Loại hợp đồng',
          thStyle: {
            width: '20%',
          },
        },
        {
          key: 'isActive',
          label: 'Trạng thái',
          tdClass: 'text-center',
          thClass: 'text-center',
          thStyle: {
            width: '15%',
          },
        },
        {
          key: 'createdByName',
          label: 'Người tạo',
          thStyle: {
            width: '20%',
          },
        },
        {
          key: 'createdAt',
          label: 'Ngày tạo',
          thStyle: {
            width: '10%',
          },
        },
        {
          key: 'actions',
          label: ' ',
          tdClass: 'text-center',
          thStyle: {
            width: '5%',
          },
        },
      ],
      onLoadingList: false,
      apiParams: {
        page: 1,
        limit: 20,
      },
    };
  },
  created() {
    this.fetchMainData();
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Thuế TNCN', route: 'tax-configs' },
    ]);
  },
  methods: {
    fetchMainData: async function (page) {
      this.apiParams.page = page ? page : 1;
      this.apiParams.mode = this.$route.params.mode;

      this.onLoadingList = true;
      ApiService.query('/tax-config', {
        params: { ...this.apiParams },
      })
        .then((response) => {
          const respData = response.data.data;
          this.mainList = respData;
          this.onLoadingList = false;
        })
        .catch((err) => {
          if (!err.response) {
            // network error
            makeToastFaile('Lỗi!');
          } else {
            const message = err.response.data.message;
            makeToastFaile(message);
          }
          this.onLoadingList = false;
          this.$nprogress.done();
        });
    },
    showTaxConfigModal(configId) {
      setTimeout(() => {
        this.$refs['tax-config-modal'].showModal(configId);
      }, TIME_TRIGGER);
    },
  },
};
</script>
<style lang="scss">
.tax-config {
  table {
    td {
      vertical-align: middle !important;
    }
  }
}
</style>
